/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class ConnectionsRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      connections: this.store.findAll(`wonde/connection`),
      schools: this.store.findAll('school'),
      update: () => this.refresh(),
    });
  }
}
